import { OnlineBackOfficeQuery } from './services/online-back-office';

class API {
    constructor(public onlineBackOffice: OnlineBackOfficeQuery) {}
}

export const api = new API(new OnlineBackOfficeQuery());
